import { Title } from '@zenterprise-inc/ui';
import { useState } from 'react';

import JointCertificateProgramDownloadCompleteGuide from './JointCertificateProgramDownloadCompleteGuide';
import JointCertificateProgramDownloadGuide from './JointCertificateProgramDownloadGuide';
import JointCertificateProgramInstallGuideDialog from './JointCertificateProgramInstallGuideDialog';

import { downloadJointCertificateProgram } from '@/components/tax-refund/common/utils/downloadJointCertificateProgram';
import { checkJoinCertificateServer } from '@/lib/utils/joint-certificate';

interface Props {
  viewController: {
    moveJointCertificateSelectPage: () => void;
  };
}

const JointCertificateInstallView = ({ viewController }: Props) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [downloadClicked, setDownloadClicked] = useState(false);

  (async () => {
    try {
      await checkJoinCertificateServer();
      viewController.moveJointCertificateSelectPage();
    } catch (error) {
      console.log(error);
    }
  })();

  const downloadFile = () => {
    downloadJointCertificateProgram();

    setDownloadClicked(true);
  };

  const handleClick = async () => {
    try {
      await checkJoinCertificateServer();
      viewController.moveJointCertificateSelectPage();
    } catch (error) {
      setOpenDialog(true);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <div className="page-padding flex w-full flex-col">
      <Title.Headline size="large" title={'공동인증서를 불러오기 위해\n필수 프로그램을 설치해주세요'} />
      <div className="pb-[80px]" />
      {downloadClicked ? (
        <JointCertificateProgramDownloadCompleteGuide handleDownload={downloadFile} handleClick={handleClick} />
      ) : (
        <JointCertificateProgramDownloadGuide handleDownload={downloadFile} />
      )}
      <JointCertificateProgramInstallGuideDialog isOpen={openDialog} handleClose={handleClose} />
    </div>
  );
};

export default JointCertificateInstallView;
